import React from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import {
  Grid,
} from "@mui/material";
import {
  GeneralInfo,
  Settings,
} from "../../containers/LinkingInfoForm";
import { mainBackgroundStyles } from "../../styles/common";

function Linking() {
  const { id: linkingId } = useParams();

  return (
    <>
      <Helmet>
        <title>{linkingId ? `Update linking: ${linkingId}` : "Create linking"}</title>
      </Helmet>
      <Grid
        container
        direction="column"
        sx={mainBackgroundStyles}
      >
        <Grid>
          <GeneralInfo />
        </Grid>
        <Grid>
          <Settings />
        </Grid>
      </Grid>
    </>
  );
}

export default Linking;
